import ThemeMixin from '@/mixins/templates/theme';
import SyncSummaryList from '../sync-summary-list';

export default {
  name       : 'SyncSummaryListDetailModal',
  mixins     : [ThemeMixin],
  components : {
    SyncSummaryList
  },
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    modalTitle: {
      type     : String,
      required : true
    },
    modalWidth: {
      type    : String,
      default : '600'
    },
    tableHeaders: {
      type    : Array,
      default : () => []
    },
    tableItems: {
      type    : Array,
      default : () => []
    },
    type: {
      type      : String,
      default   : 'contentTypes',
      validator : function(value) {
        return ['associatedCourses', 'contentTypes'].includes(value);
      }
    }
  },
  data() {
    return {
      listHeaders: []
    };
  },
  computed: {
    isDarkTheme() {
      return this.currentTheme === 'theme--plataforma-black';
    },
    getTypeCountText() {
      return this.type === 'associatedCourses'
        ? this.$t('content.modalContentSync.syncSummary.associatedCourses.countText', { amount: this.tableItems.length || 0 })
        : this.$t('content.modalContentSync.syncSummary.contentTypes.countText', { amount: this.tableItems.length || 0 });
    },
    getEmptyStateTitle() {
      return this.type === 'associatedCourses'
        ? this.$t('content.modalContentSync.syncSummary.associatedCourses.emptyTitle')
        : this.$t('content.modalContentSync.syncSummary.contentTypes.emptyTitle');
    },
    getEmptyStateText() {
      return this.type === 'associatedCourses'
        ? this.$t('content.modalContentSync.syncSummary.associatedCourses.emptyText')
        : this.$t('content.modalContentSync.syncSummary.contentTypes.emptyText');
    }
  }
};